import { isDynamicImportError } from '@/lib/lazyWithRecovery';
import { Button, Result } from 'antd';
import { useRouteError } from 'react-router-dom';

export function RouteErrorPage() {
  const error = useRouteError();
  const chunkFailure = isDynamicImportError(error);

  return (
    <Result
      status="warning"
      title={chunkFailure ? '页面资源加载失败' : '页面暂时无法打开'}
      subTitle={
        chunkFailure
          ? '网络波动或版本更新可能导致页面文件未加载完成，请刷新后重试。'
          : '页面运行时出现异常，请刷新后重试；如果仍然失败，请联系平台管理员。'
      }
      extra={
        <Button type="primary" onClick={() => window.location.reload()}>
          刷新重试
        </Button>
      }
    />
  );
}
